import React from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';

const themes = {
  teal: {
    name: 'Teal & Sky Blue',
    background: 'linear-gradient(to bottom, #e8f4f8, #f0f9fc)',
  },
  warm: {
    name: 'Brown & Lavender',
    background: 'linear-gradient(to bottom, #f5f0ed, #faf8f5)',
  },
  green: {
    name: 'Lime & Forest',
    background: 'linear-gradient(to bottom, #f0f8ed, #f5faf2)',
  },
  blue: {
    name: 'Bright Blue',
    background: 'linear-gradient(to bottom, #e8f4fd, #f0f9ff)',
  },
  neutral: {
    name: 'Neutral Cream',
    background: 'linear-gradient(to bottom, #e8e8e8, #f5f5f5)',
  },
  pastel: {
    name: 'Sky Blue & Lavender',
    background: 'linear-gradient(to bottom, #f0f4fd, #f8f5ff)',
  },
  gradient: {
    name: 'Vibrant Gradient',
    background: 'linear-gradient(to bottom right, #74C0E6, #FEFDF6, rgba(189, 182, 253, 0.3))',
  },
};

const ThemeSelector = ({ selectedTheme, onThemeSelect }) => {
  return (
    <Box>
      <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
        Theme
      </Typography>
      <Grid container spacing={2}>
        {Object.entries(themes).map(([key, theme]) => (
          <Grid item xs={6} sm={4} md={3} key={key}>
            <Paper
              elevation={selectedTheme === key ? 4 : 1}
              sx={{
                p: 1.5,
                cursor: 'pointer',
                border: selectedTheme === key ? 2 : 1,
                borderColor: selectedTheme === key ? 'primary.main' : 'divider',
                transition: 'all 0.2s ease',
                height: 110,
                display: 'flex',
                flexDirection: 'column',
                '&:hover': {
                  elevation: 3,
                  transform: 'translateY(-2px)',
                },
              }}
              onClick={() => onThemeSelect(key)}
            >
              <Box
                sx={{
                  width: '100%',
                  height: 60,
                  borderRadius: 1,
                  mb: 1,
                  background: theme.background,
                  border: '1px solid',
                  borderColor: 'divider',
                  flexShrink: 0,
                }}
              />
              <Box sx={{ 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'space-between',
                height: 24,
                flexShrink: 0,
              }}>
                <Typography 
                  variant="caption" 
                  sx={{ 
                    fontSize: '0.75rem', 
                    fontWeight: 500,
                    lineHeight: 1.2,
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    flex: 1,
                    pr: 0.5,
                  }}
                >
                  {theme.name}
                </Typography>
                {selectedTheme === key && (
                  <CheckCircle color="primary" sx={{ fontSize: 18, flexShrink: 0 }} />
                )}
              </Box>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ThemeSelector;

